export const SkeletonResultList = ({ isMobile }: { isMobile?: boolean }) => (
    <section className="grid grid-cols-1 md:grid-cols-2 gap-16" data-testid="skeletonScreen">
        {Array.from(Array(isMobile ? 5 : 10).keys()).map((_, index) => (
            /* biome-ignore lint/suspicious/noArrayIndexKey: index isn't useless here */
            <article key={`skeletonOffer-${index}`}>
                <div className="pr-4">
                    <div className="m-0 py-64 skeleton-screen" />
                    <div className="m-0 py-32 skeleton-screen" />
                    <div className="m-0 py-8 skeleton-screen" />
                    <div className="mb-8 py-2 skeleton-screen" />
                </div>
                <div className="pr-16">
                    <div className="py-4" />
                    <div className="mb-0 py-4 w-1/4 skeleton-screen" />
                    <div className="mb-16 u-pv2 w-1/4 skeleton-screen" />

                    <div className="mb-16 u-pv8 w-full skeleton-screen" />

                    <div className="mb-16 u-pv8 w-2/3 skeleton-screen" />

                    <div className="mb-0 u-pv4 w-1/2 skeleton-screen" />
                    <div className="mb-16 u-pv2 w-1/2 skeleton-screen" />
                </div>
            </article>
        ))}
    </section>
);
